// extracted by mini-css-extract-plugin
module.exports = {"address":"AddressList_address__3OWJV","selectedAddress":"AddressList_selectedAddress__2JD_N"};